import React from "react";

/* This file is generated by bin/gen-svgIcons.js */
var apps = function apps(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M23.523 11.82h8.36v8.36h-8.36v-8.36zm0-11.702h8.36v8.359h-8.36V.117zM11.82 23.523h8.36v8.36h-8.36v-8.36zm0-11.703h8.36v8.36h-8.36v-8.36zm0-11.702h8.36v8.359h-8.36V.117zM.118 23.523h8.359v8.36H.117v-8.36zm0-11.703h8.359v8.36H.117v-8.36zm0-11.702h8.359v8.359H.117V.117zm23.405 23.405h8.36v8.36h-8.36v-8.36z"
  }));
};

apps.defaultProps = {
  viewBox: "0 0 32 32"
};

var arrowLeft = function arrowLeft(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M14 9H7.001v3L2 8l5.001-4v2.999H14z",
    fillRule: "evenodd"
  }));
};

arrowLeft.defaultProps = {
  viewBox: "0 0 16 16"
};

var arrowRight = function arrowRight(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M2 9h6.999v3L14 8 8.999 4v2.999H2z",
    fillRule: "evenodd"
  }));
};

arrowRight.defaultProps = {
  viewBox: "0 0 16 16"
};

var autofill = function autofill(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.295 4c.386 0 .621.257.705.77v7.525c0 .47-.235.705-.705.705H3.725c-.382 0-.624-.242-.725-.725V7.168l1.5 1.476v2.868h9.008v-6.01H7.671L6.17 4zM8.721 7.832L10 11 6.84 9.718l1.881-1.886zM2.861 2l5.054 5.066-1.862 1.867L1 3.866 2.862 2z"
  }));
};

autofill.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var bell = function bell(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M14 .5c6.3 0 7.875 4.5 7.875 11.25 0 4.5 1.125 6.75 5.625 6.75v2.25H.5V18.5c4.5 0 5.625-2.25 5.625-6.75C6.125 5 7.7.5 14 .5zM9.5 23h9c0 2.475-2.025 4.5-4.5 4.5S9.5 25.25 9.5 23z"
  }));
};

bell.defaultProps = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28"
};

var bloombergLogo = function bloombergLogo(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.88 16.527c1.457 0 2.594-.27 3.413-.81.816-.541 1.225-1.335 1.225-2.381 0-1.098-.378-1.89-1.134-2.379-.756-.488-1.845-.732-3.268-.732H2.61v6.302h3.27zM6.01 8.03c1.106 0 1.993-.25 2.662-.746.668-.497 1.001-1.207 1.001-2.13 0-.995-.368-1.705-1.107-2.133-.738-.426-1.73-.64-2.979-.64H2.61V8.03H6.01zm.421-7.82c1.776 0 3.194.406 4.258 1.216 1.063.81 1.594 1.966 1.594 3.466 0 1.028-.298 1.892-.896 2.588-.597.698-1.388 1.177-2.373 1.439 1.249.191 2.25.662 3.005 1.464.756.802 1.134 1.83 1.134 3.085 0 1.657-.645 2.947-1.937 3.87-1.293.925-2.984 1.387-5.074 1.387H0V.209h6.432zm9.357 18.515V0h2.478v18.724H15.79zm4.93-6.224c0-1.865.642-3.417 1.925-4.655 1.283-1.237 2.882-1.856 4.797-1.856 1.898 0 3.497.614 4.798 1.844 1.3 1.229 1.951 2.784 1.951 4.667s-.642 3.447-1.925 4.693c-1.282 1.247-2.891 1.87-4.824 1.87-1.933 0-3.537-.623-4.81-1.87-1.274-1.246-1.912-2.81-1.912-4.693zm2.557 0c0 1.255.378 2.319 1.133 3.19.756.872 1.767 1.308 3.032 1.308 1.265 0 2.276-.436 3.031-1.308.756-.871 1.134-1.935 1.134-3.19 0-1.272-.382-2.337-1.146-3.19-.765-.854-1.77-1.282-3.02-1.282-1.246 0-2.252.428-3.017 1.282-.764.853-1.147 1.918-1.147 3.19zm12.469 0c0-1.865.642-3.417 1.925-4.655 1.281-1.237 2.88-1.856 4.796-1.856 1.898 0 3.498.614 4.798 1.844 1.301 1.229 1.95 2.784 1.95 4.667s-.641 3.447-1.924 4.693c-1.282 1.247-2.89 1.87-4.824 1.87-1.933 0-3.536-.623-4.81-1.87-1.275-1.246-1.911-2.81-1.911-4.693zm2.557 0c0 1.255.378 2.319 1.133 3.19.755.872 1.766 1.308 3.031 1.308 1.266 0 2.277-.436 3.032-1.308.755-.871 1.133-1.935 1.133-3.19 0-1.272-.382-2.337-1.146-3.19-.764-.854-1.771-1.282-3.019-1.282-1.247 0-2.253.428-3.017 1.282-.766.853-1.147 1.918-1.147 3.19zm15.711-4.132c.316-.662.82-1.224 1.515-1.686.695-.463 1.516-.693 2.464-.693.844 0 1.604.192 2.281.574.676.385 1.208 1.02 1.594 1.91a4.439 4.439 0 0 1 1.768-1.844 4.951 4.951 0 0 1 2.478-.64c1.422 0 2.555.453 3.399 1.359.845.908 1.265 2.136 1.265 3.688v7.687H68.3v-6.877c0-1.237-.234-2.18-.699-2.825-.466-.644-1.155-.967-2.068-.967-.967 0-1.737.367-2.307 1.098-.572.732-.857 1.692-.857 2.877v6.694H59.89V11.35c0-1.152-.228-1.989-.684-2.512-.458-.523-1.107-.784-1.952-.784-.913 0-1.673.371-2.28 1.112-.606.741-.908 1.73-.908 2.968v6.59h-2.48V8.995c0-.331-.008-.759-.025-1.282a26.815 26.815 0 0 0-.079-1.385h2.345a22.245 22.245 0 0 1 .106 2.039h.08zm21.774 8.394v1.961h-2.4V0h2.478v8.185h.079c.422-.61 1.01-1.129 1.766-1.555.756-.428 1.651-.642 2.69-.642 1.826 0 3.325.624 4.493 1.87 1.17 1.247 1.753 2.793 1.753 4.642 0 1.866-.584 3.425-1.753 4.682-1.168 1.254-2.685 1.881-4.547 1.881a5.785 5.785 0 0 1-2.557-.588 4.788 4.788 0 0 1-1.95-1.713h-.052zm-.08-4.236c0 1.238.403 2.293 1.212 3.164.808.872 1.81 1.307 3.005 1.307 1.248 0 2.255-.426 3.02-1.28.763-.854 1.145-1.928 1.145-3.217 0-1.272-.378-2.336-1.133-3.19-.755-.854-1.766-1.28-3.032-1.28-1.212 0-2.218.443-3.017 1.332-.8.89-1.2 1.943-1.2 3.164zm15.051.733c.035 1.046.45 1.935 1.24 2.667.79.732 1.73 1.098 2.82 1.098.844 0 1.573-.183 2.189-.55.614-.365 1.097-.81 1.45-1.333l1.738 1.386c-.667.872-1.453 1.512-2.359 1.922-.904.41-1.91.615-3.017.615-1.934 0-3.516-.61-4.745-1.83-1.23-1.221-1.846-2.78-1.846-4.682 0-1.918.62-3.491 1.86-4.72 1.237-1.23 2.77-1.843 4.599-1.843 1.845 0 3.309.58 4.388 1.738 1.081 1.16 1.622 2.794 1.622 4.903 0 .28-.01.488-.026.629h-9.913zm7.435-1.83c-.036-1.081-.366-1.937-.988-2.564-.624-.628-1.464-.942-2.518-.942-1.055 0-1.956.345-2.703 1.033-.747.69-1.155 1.513-1.226 2.472h7.435zm4.902-2.433c0-.33-.01-.76-.026-1.282a25.588 25.588 0 0 0-.08-1.385h2.347c.035.313.061.675.079 1.084.017.41.026.746.026 1.008h.08a4.287 4.287 0 0 1 1.542-1.765 4.048 4.048 0 0 1 2.28-.667c.386 0 .711.034.975.104l-.105 2.274a4.722 4.722 0 0 0-1.134-.13c-1.072 0-1.924.367-2.557 1.099-.634.731-.949 1.69-.949 2.876v6.512h-2.478V8.996zm9.464 11.846c.545.61 1.226 1.098 2.043 1.464.817.367 1.656.55 2.517.55 1.46 0 2.558-.388 3.295-1.164.738-.777 1.108-1.915 1.108-3.413v-1.596h-.054a4.39 4.39 0 0 1-1.87 1.596 5.967 5.967 0 0 1-2.532.549c-1.845 0-3.356-.605-4.533-1.817-1.179-1.212-1.766-2.732-1.766-4.564 0-1.83.587-3.364 1.766-4.602 1.177-1.238 2.68-1.856 4.508-1.856.895 0 1.752.191 2.57.574a4.42 4.42 0 0 1 1.936 1.752h.053V6.33h2.4v11.767c0 2.214-.598 3.918-1.794 5.112-1.194 1.194-2.9 1.792-5.112 1.792a9.704 9.704 0 0 1-3.283-.589c-1.099-.392-2.042-.945-2.833-1.66l1.581-1.909zm9.148-8.446c0-1.239-.41-2.275-1.227-3.113-.817-.837-1.823-1.254-3.018-1.254-1.195 0-2.184.405-2.966 1.215-.78.81-1.172 1.861-1.172 3.152 0 1.237.391 2.275 1.172 3.11.782.837 1.77 1.256 2.966 1.256 1.23 0 2.244-.413 3.045-1.242.799-.827 1.2-1.869 1.2-3.124z"
  }));
};

bloombergLogo.defaultProps = {
  width: "124",
  height: "25",
  viewBox: "0 0 124 25"
};

var bloombergTerminalAlt = function bloombergTerminalAlt(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M20 15h155q5 0 5 5v120q0 5-5 5H20q-5 0-5-5V20q0-5 5-5zm180 0h155q5 0 5 5v120q0 5-5 5H200q-5 0-5-5V20q0-5 5-5zm-30 167v13c0 10 35 10 35 0v-13a60 25 0 1 1-35 0z"
  }));
};

bloombergTerminalAlt.defaultProps = {
  viewBox: "0 0 375 248",
  fill: "none",
  fillOpacity: "0",
  stroke: "currentColor",
  strokeWidth: "5",
  strokeLinecap: "round"
};

var bloombergTerminal = function bloombergTerminal(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M20 15h155q5 0 5 5v120q0 5-5 5H20q-5 0-5-5V20q0-5 5-5zm180 0h155q5 0 5 5v120q0 5-5 5H200q-5 0-5-5V20q0-5 5-5zm-30 167v13c0 10 35 10 35 0v-13a60 25 0 1 1-35 0z"
  }));
};

bloombergTerminal.defaultProps = {
  viewBox: "0 0 375 248"
};

var calendar = function calendar(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M25.25 5v4.502H18.5V5h-9v4.502H2.75V5H.5v22.5h27V5h-2.25zm0 20.25H2.75V14h22.5v11.25zM20.75.5H23v6.75h-2.25V.5zM5 .5h2.25v6.75H5V.5z"
  }));
};

calendar.defaultProps = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28"
};

var caretDown = function caretDown(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.063.625h11.875L6 7.375z"
  }));
};

caretDown.defaultProps = {
  viewBox: "0 0 12 8"
};

var chart = function chart(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M2 14v-4h2v4H2zm3 0V3h2.001v11H5zm3 0V6h2v8H8zm3 0V9h2v5h-2z",
    fillRule: "evenodd"
  }));
};

chart.defaultProps = {
  viewBox: "0 0 16 16"
};

var checkCircleAlt = function checkCircleAlt(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M8 1.5c3.588 0 6.5 2.912 6.5 6.5s-2.912 6.5-6.5 6.5A6.502 6.502 0 0 1 1.5 8c0-3.588 2.912-6.5 6.5-6.5zm0 1A5.502 5.502 0 0 0 2.5 8c0 3.036 2.464 5.5 5.5 5.5s5.5-2.464 5.5-5.5S11.036 2.5 8 2.5z"
  }), React.createElement("path", {
    d: "M6.8 11l-3-3 .846-.846L6.8 9.302l4.554-4.554.846.852z"
  })));
};

checkCircleAlt.defaultProps = {
  viewBox: "0 0 16 16"
};

var checkCircle = function checkCircle(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 14.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM5.562 7.187L4.75 8l2.438 2.438 4.062-4.063-.813-.813-3.25 3.25-1.625-1.624z"
  }));
};

checkCircle.defaultProps = {
  viewBox: "0 0 16 16"
};

var checkboxMulti = function checkboxMulti(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.25.25h31.5v31.5H.25V.25zM7 13.75v4.5h18v-4.5H7z"
  }));
};

checkboxMulti.defaultProps = {
  viewBox: "0 0 32 32"
};

var checkboxOff = function checkboxOff(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M1 1h26v26H1z"
  }));
};

checkboxOff.defaultProps = {
  viewBox: "0 0 28 28"
};

var checkboxOn = function checkboxOn(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.5.5h27v27H.5V.5zm21.365 5.063L10.177 17.25l-4.265-4.267-2.6 2.597 6.865 6.864L24.462 8.16l-2.597-2.598z"
  }));
};

checkboxOn.defaultProps = {
  viewBox: "0 0 28 28"
};

var checkmark = function checkmark(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M23.125.875L8.95 15.05 3.777 9.875l-3.152 3.15L8.95 21.35 26.275 4.025z"
  }));
};

checkmark.defaultProps = {
  viewBox: "0 0 27 22"
};

var chevronDoubleDown = function chevronDoubleDown(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M13.056 8.5L22.9.626l2.811 3.514-12.655 10.124L.4 4.14 3.211.625l9.845 7.876zm0 11.25l9.844-7.875 2.811 3.514-12.655 10.124L.4 15.39l2.811-3.514 9.845 7.876z"
  }));
};

chevronDoubleDown.defaultProps = {
  viewBox: "0 0 26 26"
};

var chevronDoubleLeft = function chevronDoubleLeft(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M25.513 22.9L22 25.711 11.875 13.056 21.999.4l3.514 2.811-7.875 9.845 7.875 9.844zM6.388 13.056l7.875 9.844-3.514 2.811L.625 13.056 10.749.4l3.514 2.811-7.875 9.845z"
  }));
};

chevronDoubleLeft.defaultProps = {
  viewBox: "0 0 26 26"
};

var chevronDoubleRight = function chevronDoubleRight(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.627 3.212L4.14.401l10.124 12.655L4.141 25.712.627 22.901l7.875-9.845L.627 3.212zm19.125 9.844l-7.875-9.844L15.39.401l10.124 12.655-10.124 12.656-3.514-2.811 7.875-9.845z"
  }));
};

chevronDoubleRight.defaultProps = {
  viewBox: "0 0 26 26"
};

var chevronDoubleUp = function chevronDoubleUp(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M13.056 17.638L3.21 25.513.4 22l12.656-10.124L25.71 21.999 22.9 25.513l-9.844-7.875zM3.21 14.263L.4 10.75 13.056.625 25.71 10.749 22.9 14.263l-9.844-7.875-9.845 7.875z"
  }));
};

chevronDoubleUp.defaultProps = {
  viewBox: "0 0 26 26"
};

var chevronDown = function chevronDown(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M16 12.687L4.45.876.25 5.094 16 21.125 31.75 5.094 27.55.875z"
  }));
};

chevronDown.defaultProps = {
  viewBox: "0 0 32 22"
};

var chevronLeft = function chevronLeft(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M9.313 16L21.124 4.45 16.906.25.875 16l16.031 15.75 4.219-4.2z"
  }));
};

chevronLeft.defaultProps = {
  viewBox: "0 0 22 32"
};

var chevronRight = function chevronRight(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M12.687 16L.876 27.55l4.218 4.2L21.125 16 5.094.25.875 4.45z"
  }));
};

chevronRight.defaultProps = {
  viewBox: "0 0 22 32"
};

var chevronUp = function chevronUp(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M16 9.313l11.55 11.811 4.2-4.218L16 .875.25 16.906l4.2 4.219z"
  }));
};

chevronUp.defaultProps = {
  viewBox: "0 0 32 22"
};

var close = function close(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M8 7.016l2.72-2.72 1.12 1.12L9.136 8.12l2.768 2.784-1.184 1.184-2.736-2.704-2.704 2.704-1.184-1.168L6.864 8.2 4.112 5.416 5.264 4.28z"
  }));
};

close.defaultProps = {
  viewBox: "0 0 16 16"
};

var comment = function comment(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M14 .75C6.543.75.5 5.66.5 11.719c0 2.615 1.129 5.01 3.006 6.892-.66 2.658-2.864 5.026-2.89 5.052a.42.42 0 0 0-.08.459.413.413 0 0 0 .386.253c3.496 0 6.117-1.677 7.414-2.71A16.083 16.083 0 0 0 14 22.687c7.457 0 13.5-4.91 13.5-10.97C27.5 5.66 21.457.75 14 .75"
  }));
};

comment.defaultProps = {
  viewBox: "0 0 28 25"
};

var compass = function compass(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M14 .5C21.456.5 27.5 6.543 27.5 14c0 7.456-6.044 13.5-13.5 13.5C6.543 27.5.5 21.456.5 14 .5 6.543 6.543.5 14 .5zM6.575 21.425l9.675-5.175 5.175-9.9-9.45 5.4-5.4 9.675zm6.3-16.2h2.475V2.75h-2.475v2.475zm0 20.25h2.475V23h-2.475v2.475zM23 15.35h2.475v-2.475H23v2.475zm-20.25 0h2.475v-2.475H2.75v2.475z"
  }));
};

compass.defaultProps = {
  viewBox: "0 0 28 28"
};

var corp = function corp(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.5 27.5V.5h15.75v27H.5zm2.25-18H14V5H2.75v4.5zm0 6.75H14v-4.5H2.75v4.5zm0 6.75H14v-4.5H2.75V23zm15.75 4.5V14h9v13.5h-9z"
  }));
};

corp.defaultProps = {
  viewBox: "0 0 28 28"
};

var courthouse = function courthouse(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.5 27.5V23h27v4.5H.5zM5 20.75v-9h4.5v9H5zm6.75 0v-9h4.5v9h-4.5zm6.75 0v-9H23v9h-4.5zM14 .5l13.498 9H.501L14 .5z"
  }));
};

courthouse.defaultProps = {
  viewBox: "0 0 28 28"
};

var diagram = function diagram(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M4 12h10v2H2V2h2v10zm9-2H6V5l2 2 5-3v6z"
  }));
};

diagram.defaultProps = {
  viewBox: "0 0 16 16"
};

var dial = function dial(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M8 1.5c3.588 0 6.5 2.912 6.5 6.5s-2.912 6.5-6.5 6.5A6.502 6.502 0 0 1 1.5 8c0-3.588 2.912-6.5 6.5-6.5zm0 1A5.502 5.502 0 0 0 2.5 8c0 3.036 2.464 5.5 5.5 5.5s5.5-2.464 5.5-5.5S11.036 2.5 8 2.5z"
  }), React.createElement("path", {
    d: "M8 8.841V7.143l3-2.46.757.973z"
  }), React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "1"
  }), React.createElement("circle", {
    cx: "8",
    cy: "4",
    r: "1"
  }), React.createElement("circle", {
    cx: "4",
    cy: "8",
    r: "1"
  }), React.createElement("circle", {
    cx: "12",
    cy: "8",
    r: "1"
  })));
};

dial.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var disk = function disk(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M18.5.5v9H5v-9H.5v27h27V7.25L20.75.5H18.5zM5 23v-9.002h18v9.003H5zm6.75-15.75V.5h4.5v6.75h-4.5z"
  }));
};

disk.defaultProps = {
  viewBox: "0 0 28 28"
};

var documentListTwo = function documentListTwo(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M1735 1527h159V79H696v142h1039v1306zM512 311v1452h1139V311H512zm981 141v1170H670V452h823zM944 589H803v142h555v-49H944v-93zm0 252H803v144h555v-49H944v-95zm0 248H803v143h555v-49H944v-94zm0 254H803v139h555v-49H944v-90z"
  }));
};

documentListTwo.defaultProps = {
  viewBox: "0 0 2406 2048"
};

var documentList = function documentList(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M1894 79H512v1684h1382V79zm-159 142v1401H670V221h1065zM866 417v142h672v-47h-532v-95H866zm140 289H866v141h672v-47h-532v-94zm0 287H866v143h672v-47h-532v-96zm0 291H866v143h672v-47h-532v-96z"
  }));
};

documentList.defaultProps = {
  viewBox: "0 0 2406 2048"
};

var download = function download(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.5 27.5V23h27v4.5H.5zM11.75.5h4.5v11.248h4.5L14 18.726 7.25 11.748h4.502V.501z"
  }));
};

download.defaultProps = {
  viewBox: "0 0 28 28"
};

var drawer = function drawer(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M2 7h12v7H2V7zm3 1.97V11h6V8.97H9.97V10H6.046V8.97H5zM3 5h10v1H3zM4 3h8v1H4z"
  })));
};

drawer.defaultProps = {
  viewBox: "0 0 16 16"
};

var duplicate = function duplicate(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M7.5 27.5V7.25h15.75V27.5H7.5zM.75.5h18V5H5.25V18.5H.75V.5z"
  }));
};

duplicate.defaultProps = {
  viewBox: "0 0 24 28"
};

var ellipsis = function ellipsis(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M18 9.5c-2.623 0-4.75-2.015-4.75-4.5S15.377.5 18 .5s4.75 2.015 4.75 4.5S20.623 9.5 18 9.5zm13.063 0c-2.624 0-4.75-2.015-4.75-4.5S28.439.5 31.063.5c2.623 0 4.75 2.015 4.75 4.5s-2.127 4.5-4.75 4.5zm-26.125 0C2.313 9.5.188 7.485.188 5S2.313.5 4.938.5C7.56.5 9.688 2.515 9.688 5S7.56 9.5 4.938 9.5z"
  }));
};

ellipsis.defaultProps = {
  viewBox: "0 0 36 10"
};

var envelopeOpen = function envelopeOpen(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M8 12l5-4v6H3V8l5 4zM8 2l5 4-5 4-5-4 5-4z",
    fillRule: "evenodd"
  }));
};

envelopeOpen.defaultProps = {
  viewBox: "0 0 16 16"
};

var envelope = function envelope(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M14 16.5l13.498-9.002V23.25H.5V7.498L14 16.5zM.5 3V.752h26.998V3L14 12 .5 3z"
  }));
};

envelope.defaultProps = {
  viewBox: "0 0 28 24"
};

var envelopes = function envelopes(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M4.574 1.032h10.395v1.04L9.77 7.097 4.574 2.073v-1.04zM9.77 9.607l5.197-5.11v7.19H4.574v-7.19l5.197 5.11zM1 5h1.714v8.333H13V15H1V5z",
    fillRule: "evenodd"
  }));
};

envelopes.defaultProps = {
  viewBox: "0 0 16 16"
};

var exclamationCircleAlt = function exclamationCircleAlt(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M8 2v-.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 1 1 0-13V2zm0 0v.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11V2zm1 7H7V4h2v5zm-1 1c.267 0 .5.095.7.286.2.19.3.424.3.701a.983.983 0 0 1-.294.714A.955.955 0 0 1 8 12a.983.983 0 0 1-.7-.286.93.93 0 0 1-.3-.701c0-.277.098-.515.294-.714A.955.955 0 0 1 8 10z"
  }));
};

exclamationCircleAlt.defaultProps = {
  viewBox: "0 0 16 16"
};

var exclamationCircle = function exclamationCircle(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M8 14.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zm-.813-4.063v1.626h1.625v-1.626H7.188zm0-5.687v4.875h1.625V4.75H7.188z"
  }));
};

exclamationCircle.defaultProps = {
  viewBox: "0 0 16 16"
};

var exclamationDiamond = function exclamationDiamond(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 .25L17.75 9 9 17.75.25 9 9 .25zM9 11.5c-.344 0-.638.124-.883.373a1.229 1.229 0 0 0-.367.893c0 .347.125.639.375.877S8.667 14 9 14c.344 0 .638-.124.883-.373.245-.25.367-.547.367-.893 0-.347-.125-.639-.375-.877A1.229 1.229 0 0 0 9 11.5zM10.25 4h-2.5v6.25h2.5V4z"
  }));
};

exclamationDiamond.defaultProps = {
  viewBox: "0 0 18 18"
};

var exclamationTriangleAlt = function exclamationTriangleAlt(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M15 13.8H.9L8.2 2.1 15 13.8zM8.7 9.6V5.7h-1v3.9h1zm-.5 2c-.1 0-.2 0-.3.1-.1.1-.1.2-.1.4 0 .1 0 .2.1.3.1.1.2.1.3.1.1 0 .2 0 .3-.1.1-.1.1-.2.1-.4 0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.1z"
  }));
};

exclamationTriangleAlt.defaultProps = {
  viewBox: "0 0 16 16"
};

var exclamationTriangle = function exclamationTriangle(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M8 1.5l6.5 13h-13L8 1.5zm-.813 4.063v4.875h1.625V5.561H7.188zm0 5.687v1.625h1.625V11.25H7.188z"
  }));
};

exclamationTriangle.defaultProps = {
  viewBox: "0 0 16 16"
};

var expand = function expand(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13.605 3.496L10.1 7 9 5.899l3.504-3.504L11.108 1H15v3.892l-1.395-1.396zm0 9.007L15 11.108V15h-3.892l1.396-1.396L9 10.101 10.101 9l3.504 3.503zM2.395 3.496L1 4.892V1h3.892L3.496 2.395 7 5.9l-1.101 1.1-3.504-3.503zm0 9.007L5.9 9 7 10.1l-3.504 3.504L4.892 15H1v-3.892l1.395 1.395z"
  }));
};

expand.defaultProps = {
  viewBox: "0 0 16 16"
};

var eye = function eye(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M7.4 10.9c-1.2-.2-2.1-1.1-2.3-2.3-.4-2.1 1.4-3.9 3.5-3.5 1.2.2 2.1 1.2 2.4 2.4.3 2-1.5 3.8-3.6 3.4M8 4C3 4 1 8 1 8s2 4 7 4 7-4 7-4-2.1-4-7-4",
    fillRule: "evenodd"
  }));
};

eye.defaultProps = {
  viewBox: "0 0 16 16"
};

var fileCabinet = function fileCabinet(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M750 149h1208l-31-70H780zm-84 186h1376l-49-112H715zm1411 74H631l-78 174h1601zm118 248H512v1106h1683V657zm-933 442v80h184v-80h90v170h-365v-170h91z"
  }));
};

fileCabinet.defaultProps = {
  viewBox: "0 0 2707 2048"
};

var fileExcel = function fileExcel(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M4 2v3h5v3.999H4V14h10V6l-4-4z"
  }), React.createElement("path", {
    fill: "#1BBC3C",
    d: "M2 8h6V6H2z"
  })));
};

fileExcel.defaultProps = {
  viewBox: "0 0 16 16"
};

var filePdf = function filePdf(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M4 2v3h5v3.999H4V14h10V6l-4-4z"
  }), React.createElement("path", {
    fill: "#E51E3C",
    d: "M2 8h6V6H2z"
  })));
};

filePdf.defaultProps = {
  viewBox: "0 0 16 16"
};

var filePowerpoint = function filePowerpoint(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M4 2v3h5v3.999H4V14h10V6l-4-4z"
  }), React.createElement("path", {
    fill: "#FB754C",
    d: "M2 8h6V6H2z"
  })));
};

filePowerpoint.defaultProps = {
  viewBox: "0 0 16 16"
};

var fileWord = function fileWord(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M4 2v3h5v3.999H4V14h10V6l-4-4z"
  }), React.createElement("path", {
    fill: "#0062DD",
    d: "M2 8h6V6H2z"
  })));
};

fileWord.defaultProps = {
  viewBox: "0 0 16 16"
};

var file = function file(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M3 2v12h10V6L9 2z",
    fillRule: "evenodd"
  }));
};

file.defaultProps = {
  viewBox: "0 0 16 16"
};

var files = function files(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, "\\", React.createElement("path", {
    fill: "currentColor",
    d: "M5 2h4l4 4v6H5V2zM3 3h1v10h8v1H3V3z"
  })));
};

files.defaultProps = {
  viewBox: "0 0 16 16"
};

var filter = function filter(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.75.75l9 12.6v9.9l4.5-2.25v-7.65L23.475.75z"
  }));
};

filter.defaultProps = {
  viewBox: "0 0 24 24"
};

var firstPage = function firstPage(props) {
  return React.createElement("svg", props, React.createElement("defs", null, React.createElement("path", {
    id: "a",
    d: "M7.25 8l5.249-5.133L10.625 1 3.5 8l7.125 7 1.875-1.867z"
  })), React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, React.createElement("use", {
    xlinkHref: "#a"
  }), React.createElement("path", {
    d: "M0 0h2v16H0z"
  })));
};

firstPage.defaultProps = {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var flag = function flag(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M3 2H2v12h1V8c7 0 6 3 11 2V4C9 5 10 2 3 2",
    fillRule: "evenodd"
  }));
};

flag.defaultProps = {
  viewBox: "0 0 16 16"
};

var folder = function folder(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.5.756v22.5h27V5.243H13.55L9.5.756z"
  }));
};

folder.defaultProps = {
  viewBox: "0 0 28 24"
};

var gear = function gear(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M14 18.5A4.513 4.513 0 0 1 9.5 14c0-2.475 2.025-4.5 4.5-4.5s4.5 2.025 4.5 4.5-2.025 4.5-4.5 4.5zm13.5-2.25v-4.5h-4.725c-.225-.9-.675-1.575-1.125-2.25l3.375-3.375-3.15-3.15L18.5 6.35c-.675-.45-1.35-.9-2.25-1.125V.5h-4.5v4.725c-.9.225-1.575.675-2.25 1.125L6.125 2.975l-3.15 3.15L6.35 9.5c-.45.675-.9 1.35-1.125 2.25H.5v4.5h4.725c.225.9.45 1.575.9 2.25l-3.15 3.375 3.15 3.15L9.5 21.65c.675.45 1.575.675 2.25.9v4.95h4.5v-4.725c.9-.225 1.575-.45 2.25-.9l3.375 3.375 3.15-3.15-3.375-3.6c.45-.675.675-1.575.9-2.25h4.95z"
  }));
};

gear.defaultProps = {
  viewBox: "0 0 28 28"
};

var headset = function headset(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 0C4.86 0 2 2.98 2 6.77V11.647c0 2.573 1.95 4.604 4.42 4.604h2.6c.39 0 .78-.406.78-.813v-1.083c0-.406-.39-.812-.78-.812H7.98c-.39 0-.78.406-.78.812v.542h-.78c-1.69 0-3.12-1.49-3.12-3.25v-.813h.65c1.04 0 1.95-.948 1.95-2.03 0-1.084-.91-2.032-1.95-2.032H3.3c0-2.98 2.34-5.417 5.2-5.417 2.86 0 5.2 2.438 5.2 5.417h-.65c-1.04 0-1.95.948-1.95 2.031 0 1.083.91 2.031 1.95 2.031H15V6.771C15 2.979 12.14 0 8.5 0z"
  }));
};

headset.defaultProps = {
  viewBox: "0 0 16 16"
};

var home = function home(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M14 .5l13.498 15.748H23V27.5h-6.75v-6.75h-4.5v6.75H4.998V16.248H.5L14 .5zm6.75 0h4.5v7.648l-4.5-5.398V.5z"
  }));
};

home.defaultProps = {
  viewBox: "0 0 28 28"
};

var infoCircleAlt = function infoCircleAlt(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M8 2v-.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 1 1 0-13V2zm0 0v.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11V2z"
  }), React.createElement("path", {
    d: "M7 12V7h2v5H7zm0-6V4h2v2H7z"
  })));
};

infoCircleAlt.defaultProps = {
  viewBox: "0 0 16 16"
};

var infoCircle = function infoCircle(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0zm-7 4h2V7H7v5zm0-6h2V4H7v2z",
    fillRule: "evenodd"
  }));
};

infoCircle.defaultProps = {
  viewBox: "0 0 16 16"
};

var key = function key(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M8.403 6.656c.582-1.326.276-2.974-.88-4.088-1.468-1.412-3.752-1.433-5.095-.047-1.344 1.387-1.243 3.662.224 5.075 1.157 1.114 2.818 1.362 4.127.736l1.042 1.003-1.623 1.676 1.772 1.707 1.624-1.676.886.854-1.623 1.676 1.773 1.707 1.623-1.676.887.854 1.623-1.676-6.36-6.125zM4.317 6.02c-.493-.476-.527-1.248-.075-1.716.451-.468 1.224-.46 1.717.016.494.476.528 1.248.076 1.716-.451.468-1.224.46-1.718-.016z"
  }));
};

key.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var lastPage = function lastPage(props) {
  return React.createElement("svg", props, React.createElement("defs", null, React.createElement("path", {
    id: "a",
    d: "M7.25 8l5.249-5.133L10.625 1 3.5 8l7.125 7 1.875-1.867z"
  })), React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, React.createElement("use", {
    transform: "matrix(-1 0 0 1 16 0)",
    xlinkHref: "#a"
  }), React.createElement("path", {
    d: "M14 0h2v16h-2z"
  })));
};

lastPage.defaultProps = {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var link = function link(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M18.773 21.955l-3.182 3.182c-3.5 3.5-9.227 3.5-12.728 0-3.5-3.5-3.5-9.228 0-12.728l3.182-3.182 3.182 3.182-3.182 3.182a4.513 4.513 0 0 0 0 6.364 4.513 4.513 0 0 0 6.364 0l3.182-3.182 3.182 3.182zm6.364-6.364l-3.182 3.182-3.182-3.182 3.182-3.182a4.513 4.513 0 0 0 0-6.364 4.513 4.513 0 0 0-6.364 0L12.41 9.227 9.227 6.045l3.182-3.182c3.5-3.5 9.228-3.5 12.728 0s3.5 9.228 0 12.728zm-14.319 4.773l-3.182-3.182 9.546-9.546 3.182 3.182-9.546 9.546z"
  }));
};

link.defaultProps = {
  viewBox: "0 0 28 28"
};

var list = function list(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M3 14h10V2H3v12zm4-8h5V4H7v2zM4 6h2V4H4v2zm3 3h5V7H7v2zM4 9h2V7H4v2zm0 2.901h2V9.9H4v2.001zM7 12h5v-2H7v2z",
    fillRule: "evenodd"
  }));
};

list.defaultProps = {
  viewBox: "0 0 16 16"
};

var lists = function lists(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M4 12h10V2H4v10zm4-7h5V3H8v2zM5 5h2V3H5v2zm3 3h5V6H8v2zM5 8h2V6H5v2zm0 2.901h2V8.9H5v2.001zM8 11h5V9H8v2z"
  }), React.createElement("path", {
    d: "M2 14h10v-.908H2.984V3H2z"
  })));
};

lists.defaultProps = {
  viewBox: "0 0 16 16"
};

var lock = function lock(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M1.688 12V8.25c0-4.125 3.29-7.5 7.312-7.5s7.313 3.375 7.313 7.5V12H18v11.25H0V12h1.688zm2.742 0h9.14V8.25c0-2.625-2.01-4.688-4.57-4.688-2.56 0-4.57 2.063-4.57 4.688V12z"
  }));
};

lock.defaultProps = {
  viewBox: "0 0 18 24"
};

var logout = function logout(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M14 27.5C6.557 27.5.5 21.697.5 14.563.5 10.486 2.539 6.6 5.956 4.17c.737-.527 1.748-.329 2.25.44.506.77.316 1.821-.422 2.345-2.569 1.83-4.044 4.604-4.044 7.608 0 5.274 4.603 9.562 10.26 9.562s10.26-4.288 10.26-9.562c0-3.002-1.473-5.774-4.037-7.601-.74-.526-.929-1.577-.423-2.347a1.58 1.58 0 0 1 2.25-.44c3.413 2.43 5.45 6.313 5.45 10.388C27.5 21.697 21.443 27.5 14 27.5zM12.875 1.625a1.125 1.125 0 0 1 2.25 0v15.747a1.125 1.125 0 1 1-2.25 0V1.625z"
  }));
};

logout.defaultProps = {
  viewBox: "0 0 28 28"
};

var magnify = function magnify(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M21.104 18.002l5.78 5.713a2.25 2.25 0 0 1-3.163 3.2l-5.815-5.747A11.197 11.197 0 0 1 11.75 23C5.537 23 .5 17.963.5 11.75S5.537.5 11.75.5 23 5.537 23 11.75c0 2.314-.698 4.464-1.896 6.252zm-9.354 1.623a7.875 7.875 0 1 0 0-15.75 7.875 7.875 0 0 0 0 15.75z"
  }));
};

magnify.defaultProps = {
  viewBox: "0 0 28 28"
};

var menu = function menu(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M23.25.75v4.5H.75V.75h22.5zm0 9v4.5H.75v-4.5h22.5zm0 9v4.5H.75v-4.5h22.5z"
  }));
};

menu.defaultProps = {
  viewBox: "0 0 24 24"
};

var minimize = function minimize(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M0 .75h18v4.5H0z"
  }));
};

minimize.defaultProps = {
  viewBox: "0 0 18 6"
};

var mobile = function mobile(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 11.5 1h-7A1.5 1.5 0 0 0 3 2.5v11A1.5 1.5 0 0 0 4.5 15zM4 12h8V2H4v10zm3 2h2v-1H7v1z"
  }));
};

mobile.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var moveHorizontal = function moveHorizontal(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M10 10.75H3.989V13L1 10l2.989-3v2.249H10zM6 6.75h6.036V9L15 6l-2.964-3v2.249H6z"
  })));
};

moveHorizontal.defaultProps = {
  viewBox: "0 0 16 16"
};

var movePoint = function movePoint(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M11 9h1.036v2L15 8l-2.964-3v2H11zM9 7h1v2H9zM7 7h1v2H7z"
  }), React.createElement("circle", {
    cx: "4",
    cy: "8",
    r: "2"
  })));
};

movePoint.defaultProps = {
  viewBox: "0 0 16 16"
};

var moveVertical = function moveVertical(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M6.25 5.5v6.011H8.5l-3 2.989-3-2.989h2.249V5.5zM9.75 10.5V4.464H7.5l3-2.964 3 2.964h-2.249V10.5z"
  })));
};

moveVertical.defaultProps = {
  viewBox: "0 0 16 16"
};

var no = function no(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M3.45 12c0-1.8.675-3.6 1.575-4.95l11.7 11.7c-1.35.9-3.15 1.575-4.95 1.575-4.5.225-8.325-3.6-8.325-8.325m17.1 0c0 1.8-.675 3.6-1.575 4.95L7.05 5.025C8.4 4.125 10.2 3.45 12 3.45A8.546 8.546 0 0 1 20.55 12M12 .75C5.7.75.75 5.7.75 12S5.7 23.25 12 23.25 23.25 18.3 23.25 12 18.3.75 12 .75"
  }));
};

no.defaultProps = {
  viewBox: "0 0 24 24"
};

var paperclip = function paperclip(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M13.606 25.9c-1.35 1.125-2.7 1.8-4.5 1.8-1.8 0-3.15-.675-4.275-1.8-2.475-2.477-2.475-6.3 0-8.55L17.881 4.3c.9-.9 1.8-1.35 2.925-1.35 1.125 0 2.025.45 2.7 1.125.675.675 1.125 1.8 1.125 2.7 0 1.125-.45 2.025-1.125 2.7L12.481 20.5c-.225.225-.675.45-1.125.45-.45 0-.9-.225-1.125-.45-.675-.675-.675-1.577 0-2.25l8.325-8.325-2.025-1.8-8.325 8.325c-.9.9-1.35 1.8-1.35 3.15 0 1.35.45 2.25 1.35 3.15.9.9 1.8 1.35 3.15 1.35 1.125 0 2.25-.45 3.15-1.35l11.025-11.025c1.35-1.35 2.025-2.925 2.025-4.725 0-1.8-.675-3.375-2.025-4.725C24.406 1.15 22.606.25 20.806.25c-1.8 0-3.6.675-4.725 2.025l-13.05 13.05c-3.375 3.375-3.375 9 0 12.375 1.575 1.575 3.825 2.473 6.3 2.473 2.475 0 4.5-.898 6.3-2.473l10.35-10.35-2.025-1.8-10.35 10.35z"
  }));
};

paperclip.defaultProps = {
  viewBox: "0 0 28 31"
};

var pencil = function pencil(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M21.854.5l5.568 5.567-15.115 15.116-5.569-5.569L21.854.501zM.5 27.35l3.825-9.45 5.625 5.625L.5 27.35z"
  }));
};

pencil.defaultProps = {
  viewBox: "0 0 28 28"
};

var plusCircleAlt = function plusCircleAlt(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M8 2v-.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 1 1 0-13V2zm0 0v.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11V2z"
  }), React.createElement("path", {
    d: "M7 12h2V4H7z"
  }), React.createElement("path", {
    d: "M4 7v2h8V7z"
  })));
};

plusCircleAlt.defaultProps = {
  viewBox: "0 0 16 16"
};

var plusCircle = function plusCircle(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0zM7 9v3h2V9h3V7H9V4H7v3H4v2h3z",
    fillRule: "evenodd"
  }));
};

plusCircle.defaultProps = {
  viewBox: "0 0 16 16"
};

var plus = function plus(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M9.672.747v9.001H.125v4.491h9.547v9.016h4.703v-9.016h9.5l-.002-4.491h-9.498V.747z"
  }));
};

plus.defaultProps = {
  viewBox: "0 0 24 24"
};

var popin = function popin(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M9.14 7.61l8.955 8.955 2.655-2.655v6.84h-6.84l2.655-2.655L7.61 9.14l1.53-1.53zm16.11 13.14v-4.502h2.25v4.502h-2.25zm0 2.25h2.25v4.5H23v-2.25h2.25V23zm0-13.5h2.25V14h-2.25v-2.25H23V9.5h2.25zM9.5 23h2.251v2.25h2.25v2.25H9.5V23zm6.75 4.5v-2.25h4.5v2.25h-4.5zM.5.5h18v9h-2.25V2.75H2.75v13.498H9.5v2.253h-9V.5z"
  }));
};

popin.defaultProps = {
  viewBox: "0 0 28 28"
};

var popout = function popout(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M5 23h18v-6.75h4.5V27.5H.5V.5h11.25V5H5v18zM23.466 7.716L13.34 17.841l-3.182-3.182L20.284 4.534 16.25.501h11.248v11.247l-4.032-4.032z"
  }));
};

popout.defaultProps = {
  viewBox: "0 0 28 28"
};

var questionCircleOutline = function questionCircleOutline(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M8 2v-.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 1 1 0-13V2zm0 0v.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11V2z"
  }), React.createElement("path", {
    d: "M7.31 9.687v-.418c0-.33.05-.612.149-.847.099-.235.291-.488.577-.759l.495-.473c.14-.125.258-.264.357-.418.1-.154.149-.341.149-.561 0-.286-.09-.526-.27-.72-.18-.195-.434-.292-.764-.292-.308 0-.568.106-.781.319-.213.213-.326.488-.341.825l-1.353-.121c.088-.697.365-1.241.83-1.634C6.825 4.196 7.402 4 8.091 4c.675 0 1.234.192 1.678.577.443.386.665.9.665 1.546 0 .543-.152.98-.457 1.314a8.749 8.749 0 0 1-.912.875c-.305.25-.457.612-.457 1.089v.286H7.31zm.66.671c.235 0 .44.08.616.242.176.161.264.36.264.594a.817.817 0 0 1-.258.605.857.857 0 0 1-.622.253.883.883 0 0 1-.616-.242.775.775 0 0 1-.264-.594c0-.235.086-.436.258-.605a.857.857 0 0 1 .622-.253z"
  })));
};

questionCircleOutline.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "1.5 1.5 13 13"
};

var questionCircle = function questionCircle(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0zM7.31 9.687h1.298v-.286c0-.477.152-.84.457-1.089.304-.25.608-.54.912-.874.305-.334.457-.772.457-1.315 0-.645-.222-1.16-.665-1.546C9.324 4.192 8.765 4 8.09 4c-.69 0-1.267.196-1.732.588-.466.393-.743.937-.831 1.634l1.353.121c.015-.337.128-.612.341-.825.213-.213.473-.319.781-.319.33 0 .585.097.764.292.18.194.27.434.27.72 0 .22-.05.407-.149.561a2.038 2.038 0 0 1-.357.418l-.495.473c-.286.271-.478.524-.577.759a2.174 2.174 0 0 0-.149.847v.418zm.66.671a.857.857 0 0 0-.622.253.817.817 0 0 0-.258.605c0 .235.088.433.264.594a.883.883 0 0 0 .616.242c.242 0 .45-.084.622-.253a.817.817 0 0 0 .258-.605.775.775 0 0 0-.264-.594.883.883 0 0 0-.616-.242z"
  }));
};

questionCircle.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "2 2 12 12"
};

var questionSquare = function questionSquare(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.25.25h31.5v31.5H.25V.25zm18 27v-4.5h-4.5v4.468l4.5.032zM14.2 20.5h3.825c0-2.213.45-2.705 1.35-3.69 2.25-1.725 3.375-3.202 3.375-5.663 0-5.907-5.4-6.397-6.975-6.397-2.925 0-6.525 1.967-6.525 7.138h3.825C13.3 10.41 13.75 8.442 16 8.442c1.125 0 2.7.49 2.7 2.951 0 1.23-.45 2.215-1.575 2.956-2.7 1.967-2.925 3.197-2.925 6.151z"
  }));
};

questionSquare.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
};

var radioOff = function radioOff(props) {
  return React.createElement("svg", props, React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "13",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    transform: "translate(-4 -4)"
  }));
};

radioOff.defaultProps = {
  viewBox: "0 0 28 28"
};

var radioOn = function radioOn(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.25 .25)"
  }, React.createElement("circle", {
    cx: "15.75",
    cy: "15.75",
    r: "15.25",
    stroke: "currentColor",
    strokeWidth: "2"
  }), React.createElement("circle", {
    cx: "15.75",
    cy: "15.75",
    r: "11.25",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

radioOn.defaultProps = {
  viewBox: "0 0 32 32"
};

var realtime = function realtime(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M13.857.429c6.857 0 12 4.928 12 11.785s-5.357 12-12 12c-6.428 0-11.571-4.928-11.786-11.357H.143l3-3.857 3.428 3.857H4.43c.214 4.929 4.5 9 9.428 8.786 5.143 0 9.429-4.286 9.429-9.429 0-5.143-4.286-9.428-9.429-9.428-2.786 0-5.571 1.285-7.286 3.643-.214.214-.428.214-.642.214-.858 0-1.286-.643-1.286-1.286 0-.214 0-.428.214-.643C7 2.143 10.214.43 13.857.43zm-.144 13.926a1.286 1.286 0 1 1-1.426-2.14l3.857-2.57a1.286 1.286 0 1 1 1.426 2.14l-3.857 2.57zM13 15.857a2.571 2.571 0 1 1 0-5.143 2.571 2.571 0 0 1 0 5.143z"
  }));
};

realtime.defaultProps = {
  viewBox: "0 0 26 25"
};

var redo = function redo(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M2.75.75h22.5v9h2.25l-4.5 4.5-4.5-4.5h2.25v-4.5h-18V.75zM.5 14.252L5 9.75l4.5 4.502H7.25v4.5h18v4.5H2.75v-9H.5z"
  }));
};

redo.defaultProps = {
  viewBox: "0 0 28 24"
};

var refreshSquare = function refreshSquare(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M2.75.75h22.5v9h2.25l-4.5 4.5-4.5-4.5h2.25v-4.5h-18V.75zM.5 14.252L5 9.75l4.5 4.502H7.25v4.5h18v4.5H2.75v-9H.5z"
  }));
};

refreshSquare.defaultProps = {
  viewBox: "0 0 28 24"
};

var refresh = function refresh(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M23.505 4.495L27.5.5v11.25H16.25l5.276-5.276C19.593 4.54 16.947 3.313 14 3.313c-5.119 0-9.4 3.623-10.438 8.438H.701C1.776 5.368 7.313.5 14 .5c3.73 0 7.067 1.548 9.506 3.994zm.934 11.755h2.86c-1.076 6.383-6.61 11.25-13.3 11.25-3.728 0-7.065-1.548-9.504-3.994L.5 27.5V16.25h11.25l-5.274 5.276c1.933 1.935 4.577 3.162 7.524 3.162 5.121 0 9.403-3.623 10.44-8.438z"
  }));
};

refresh.defaultProps = {
  viewBox: "0 0 28 28"
};

var restricted = function restricted(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M13.775 27.05C6.35 27.05.5 21.2.5 13.775.5 6.35 6.35.5 13.775.5 21.2.5 27.05 6.35 27.05 13.775c0 7.425-5.85 13.275-13.275 13.275zM7.25 15.8h13.5v-4.5H7.25v4.5z"
  }));
};

restricted.defaultProps = {
  viewBox: "0 0 28 28"
};

var scaleDown = function scaleDown(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M10.395 4.503L13.9 1 15 2.1l-3.504 3.504L12.892 7H9V3.108l1.395 1.395zm-4.79 6.993L2.1 15 1 13.899l3.504-3.504L3.108 9H7v3.892l-1.395-1.396z"
  }));
};

scaleDown.defaultProps = {
  viewBox: "0 0 16 16"
};

var scaleUp = function scaleUp(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13.605 3.496L10.1 7 9 5.899l3.504-3.504L11.108 1H15v3.892l-1.395-1.396zm-11.21 9.007L5.9 9 7 10.1l-3.504 3.504L4.892 15H1v-3.892l1.395 1.395z"
  }));
};

scaleUp.defaultProps = {
  viewBox: "0 0 16 16"
};

var share = function share(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2a2 2 0 1 1-1.53 3.289L5.876 7.3a1.996 1.996 0 0 1-.021 1.451l4.592 1.989a2 2 0 1 1-.416.91L5.234 9.574a2 2 0 1 1 .052-3.106l4.751-2.082A2 2 0 0 1 12 2z"
  }));
};

share.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var star = function star(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M15 .5l-4.275 9L.75 10.85l7.123 6.973L5.975 27.5 15 23l9.025 4.5-1.9-9.677 7.123-6.973-9.736-1.35z"
  }));
};

star.defaultProps = {
  viewBox: "0 0 30 28"
};

var stop = function stop(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.471 2.043L10.424 2l3.533 3.471.043 4.953-3.471 3.533L5.576 14l-3.533-3.471L2 5.576l3.471-3.533zM8 7.103L5.898 5l-.886.873 2.115 2.14L5 10.102l.91.897 2.078-2.078L10.09 11l.91-.91-2.127-2.14 2.078-2.077-.86-.86L8 7.102z"
  }));
};

stop.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var subscribe = function subscribe(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M14 16.5l13.498-9.002V23.25H.5V7.498L14 16.5zM.5 3V.752h26.998V3L14 12 .5 3z"
  }));
};

subscribe.defaultProps = {
  viewBox: "0 0 28 24"
};

var talkBubble = function talkBubble(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 2v12l3-4h9V2z"
  }));
};

talkBubble.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var thumbsDownFill = function thumbsDownFill(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M9.025 4h1v5l-2 2-1 3c-1.3 0-1.6-.9-1.3-2 .3-1.1.6-2 .6-2h-3c-1 0-1.6-.5-1.2-1.5.3-.8.9-2.5 1.7-4 .5-.9.3-1.5 1.2-1.5h3c.5 0 1 0 1 1zm5-1v7h-3V3h3z",
    fillRule: "evenodd"
  }));
};

thumbsDownFill.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var thumbsDownOutline = function thumbsDownOutline(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M8.073 2l.061.002a.94.94 0 0 1 .877.89v.11h1v5l-2 2-.97 3c-1.3 0-1.6-.9-1.3-2 .264-.97.529-1.785.587-1.964l.012-.036h-3c-1 0-1.6-.5-1.23-1.5a33.108 33.108 0 0 1 1.7-4c.47-.94.41-1.44 1.068-1.495l.132-.005h3L8.073 2zM8.01 3.002H5.13l-.06.17c-.08.21-.18.47-.34.78a29.716 29.716 0 0 0-1.375 3.01l-.235.62-.11.3v.12c.073.01.146.013.22.01l.11-.01h4.38l-.44 1.34.05-.05 1.68-1.7v-3.59h-1v-1zm6-1v7h-3v-7h3zm-1 1h-1v5h1v-5z",
    fillRule: "evenodd"
  }));
};

thumbsDownOutline.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var thumbsUpFill = function thumbsUpFill(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M5 6v7H2V6h3zm4-4c1.3 0 1.6.9 1.3 2-.3 1.1-.6 2-.6 2h3c1 0 1.6.5 1.2 1.5-.3.8-.9 2.5-1.7 4-.5 1-.4 1.5-1.2 1.5H8c-.5 0-1-.3-1-1H6V7l2-2 1-3z",
    fillRule: "evenodd"
  }));
};

thumbsUpFill.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var thumbsUpOutline = function thumbsUpOutline(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M5 7v7H2V7h3zm4-4c1.3 0 1.6.9 1.3 2a42.382 42.382 0 0 1-.597 1.99L9.7 7h3c1 0 1.6.5 1.2 1.5-.5 1.4-1 2.7-1.7 4-.47.941-.41 1.44-1.068 1.495L11 14H7.9c-.464 0-.842-.431-.894-.893L7 13H6V8l2-2 1-3zM4 8H3v5h1V8zm4.8-1.3L7 8.4V12h1v1h2.9l.1-.2c0-.2.1-.5.3-.8.514-1.029 1.029-2.057 1.417-3.086L12.9 8.4l.1-.3V8H8.3l.5-1.3z",
    fillRule: "evenodd"
  }));
};

thumbsUpOutline.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var timer = function timer(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M10 7.25c5.28 0 9.563 4.534 9.563 10.125S15.28 27.5 10 27.5C4.72 27.5.437 22.966.437 17.375S4.72 7.25 10 7.25zM5.75.5h8.5v2.25h-2.125V5h-4.25V2.75H5.75V.5zm10.413 16.875c0-3.6-2.763-6.525-6.163-6.525v6.525h6.163z"
  }));
};

timer.defaultProps = {
  viewBox: "0 0 20 28"
};

var trash = function trash(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M3 27.5v-18h18v18H3zM7.5.5h9.002v2.25h6.747V5H.75V2.75H7.5V.5z"
  }));
};

trash.defaultProps = {
  viewBox: "0 0 24 28"
};

var undo = function undo(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M17.8.5C10.375.5 4.3 6.575 4.3 14H.25l6.3 6.3 6.3-6.3H8.8c0-4.95 4.05-9 9-9s9 4.05 9 9-4.05 9-9 9v4.5c7.425 0 13.5-6.075 13.5-13.5S25.225.5 17.8.5"
  }));
};

undo.defaultProps = {
  viewBox: "0 0 32 28"
};

var unlink = function unlink(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M8.426 26.805c-1.718 0-3.682-.737-4.91-1.964-1.226-1.227-1.963-3.19-1.963-4.91 0-1.963.737-3.68 1.964-4.908l3.19-3.191 3.437 3.436-3.436 2.946c-.246.245-.491.982-.491 1.472 0 .491.245 1.228.736 1.473.737.737 2.21.737 2.946 0l3.19-3.19 3.437 3.436-3.19 3.19c-1.474 1.473-3.192 2.21-4.91 2.21zm13.01-10.31l-3.437-3.436 3.19-3.19c.737-.737.737-2.21 0-2.946-.736-.982-2.208-.982-2.945-.246l-3.436 3.437-3.437-3.682 3.191-3.191c2.7-2.7 7.364-2.7 10.064 0s2.7 7.118 0 10.064l-3.19 3.19zM3.41 4.972l1.736-1.735 3.299 3.296-1.738 1.735L3.41 4.971zm5.02-3.695L10.76.5l1.085 3.26-2.327.775-1.087-3.26zM.5 10.783l.776-2.33 3.26 1.088-.776 2.33L.5 10.782zm19.093 10.43l1.735-1.736 3.3 3.297-1.739 1.735-3.296-3.297zm3.746-2.783l.775-2.33 3.26 1.088-.776 2.33-3.26-1.088zm-7.31 5.678l2.329-.775 1.087 3.26-2.329.775-1.087-3.26z"
  }));
};

unlink.defaultProps = {
  viewBox: "0 0 28 28"
};

var unlock = function unlock(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M12.875 12V8.25c0-4.125 3.29-7.5 7.313-7.5 4.021 0 7.312 3.375 7.312 7.5V12h-2.742V8.25c0-2.625-2.011-4.688-4.57-4.688-2.56 0-4.57 2.063-4.57 4.688V12H18.5v11.25H.5V12h12.375z"
  }));
};

unlock.defaultProps = {
  viewBox: "0 0 28 24"
};

var upload = function upload(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M8 3L5 7h2v4h2V7h2L8 3zm6 5h-3v2h1v3H4v-3h1V8H2v7h12V8z"
  }));
};

upload.defaultProps = {
  viewBox: "0 0 16 16"
};

var user = function user(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M.625 27.5v-1.882c0-3.425 1.575-4.11 5.175-5.48 1.35-.457 2.063-.913 2.7-1.142.637-.228 1.125-.685 1.35-1.37.45-2.74.45-2.74-.675-3.653-1.125-.914-1.8-2.969-1.8-4.34V6.438C7.375 2.783 10.075.5 13 .5s5.625 2.283 5.625 5.937v3.197c0 1.37-.675 3.197-1.8 4.339-.9.913-.9.913-.675 3.653 0 .685.45 1.37 1.125 1.599.675.228 1.35.456 2.7 1.141 3.825 1.142 5.4 1.827 5.4 5.252V27.5H.625z"
  }));
};

user.defaultProps = {
  viewBox: "0 0 26 28"
};

var userGear = function userGear(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M7 1c1.655 0 3.182 1.273 3.182 3.31v1.78c0 .765-.382 1.91-1.018 2.42-.406.324-.54.441-.54.88v2.235h1.362l-.846.837-.058.056 1.56 1.56c.018 0 .907-.897.907-.897v1.258c.486 0 2.195-.01 2.206 0 .05.047.245.308.245.561H0c0-.497.06-.89.188-1.212.362-.913 1.266-1.245 2.867-1.715.763-.382 1.145-.51 1.527-.637a.957.957 0 0 0 .636-.89c.127-1.528.127-1.528-.382-2.037-.636-.636-1.018-1.654-1.018-2.418V4.309C3.818 2.273 5.345 1 7 1zm6.193 6.125v1.181c.225.057.393.169.562.282l.844-.844.787.787-.843.844c.112.169.225.338.28.563h1.182v1.124h-1.181c-.056.226-.113.394-.225.563l.787.844-.787.787-.844-.844c-.169.113-.394.17-.563.225v1.238h-1.124v-1.181c-.226-.057-.394-.113-.563-.225l-.844.844-.787-.788.843-.9c-.112-.169-.168-.394-.225-.563H9.255V9.938h1.181c.056-.226.169-.394.281-.563l-.843-.844.787-.787.844.844c.169-.113.337-.225.563-.282V7.125h1.125zm-.563 2.25c-.619 0-1.125.506-1.125 1.125s.506 1.125 1.125 1.125 1.125-.506 1.125-1.125-.506-1.125-1.125-1.125z"
  }));
};

userGear.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var userKey = function userKey(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M6.773 10.656c1.204-.002 2.228.739 2.605 1.774L16 12.42l-.003 1.778-.923.001-.002 1.778-1.846.003.002-1.778-.732.001h-.19l-.003 1.614v.164l-1.418.002h-.428l.002-1.5v-.277l-1.084.001c-.38 1.037-1.406 1.78-2.61 1.782-1.528.002-2.767-1.192-2.765-2.663.002-1.471 1.245-2.668 2.773-2.67zm.07 1.787c-.514 0-.935.405-.935.9 0 .496.42.901.935.901.514 0 .935-.405.935-.9 0-.496-.42-.9-.935-.9zM5 1c1.182 0 2.273.91 2.273 2.364v1.272C7.273 5.182 7 6 6.545 6.364c-.454.363-.454.363-.272 1.454.09.273.288.455.545.546.258.09.546.272 1.091.454C9.364 9.364 10 9.636 10 11h-.698c-.829-.784-1.698-1.056-2.484-1.056-.89 0-1.8.272-2.591 1.056H0c0-.355.043-.636.134-.866.259-.652.905-.889 2.048-1.225.545-.273.818-.364 1.09-.454a.684.684 0 0 0 .455-.637c.091-1.09.091-1.09-.272-1.454-.455-.455-.728-1.182-.728-1.728V3.364C2.727 1.909 3.818 1 5 1z"
  }));
};

userKey.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var xCircleAlt = function xCircleAlt(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M8 2v-.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 1 1 0-13V2zm0 0v.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11V2z"
  }), React.createElement("path", {
    d: "M8 7.102l2.09-2.09.861.861-2.078 2.078L11 10.09l-.91.91-2.102-2.078L5.91 11 5 10.102l2.127-2.09-2.115-2.139L5.898 5z"
  })));
};

xCircleAlt.defaultProps = {
  viewBox: "0 0 16 16"
};

var xCircle = function xCircle(props) {
  return React.createElement("svg", props, React.createElement("path", {
    fill: "currentColor",
    d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0zm-6-.898L5.898 5l-.886.873 2.115 2.14L5 10.102l.91.897 2.078-2.078L10.09 11l.91-.91-2.127-2.14 2.078-2.077-.86-.86L8 7.102z",
    fillRule: "evenodd"
  }));
};

xCircle.defaultProps = {
  viewBox: "0 0 16 16"
};

var x = function x(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M21.25.75L12 10 2.75.75l-2 2 9.25 9-9.25 9.5 2 2L12 14l9.25 9.25 2-2-9.25-9.5 9.25-9z"
  }));
};

x.defaultProps = {
  viewBox: "0 0 24 24"
};

var zoom = function zoom(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M26.923 13.635l4.327 4.288c.661.655.668 1.724.014 2.388-.654.663-1.72.67-2.382.014l-4.353-4.314a8.366 8.366 0 0 1-4.608 1.375c-4.65 0-8.421-3.78-8.421-8.443S15.27.5 19.921.5c4.65 0 8.421 3.78 8.421 8.443a8.42 8.42 0 0 1-1.419 4.692zm-7.002 1.218c3.256 0 5.895-2.646 5.895-5.91 0-3.264-2.64-5.91-5.895-5.91-3.256 0-5.895 2.646-5.895 5.91 0 3.264 2.64 5.91 5.895 5.91zM9.25 14v4.506h4.5v4.5h-4.5v4.498h-4.5v-4.498H.25v-4.5h4.5V14h4.5z"
  }));
};

zoom.defaultProps = {
  viewBox: "0 0 32 28"
};
export default {
  apps: apps,
  'arrow-left': arrowLeft,
  'arrow-right': arrowRight,
  autofill: autofill,
  bell: bell,
  'bloomberg-logo': bloombergLogo,
  'bloomberg-terminal-alt': bloombergTerminalAlt,
  'bloomberg-terminal': bloombergTerminal,
  calendar: calendar,
  'caret-down': caretDown,
  chart: chart,
  'check-circle-alt': checkCircleAlt,
  'check-circle': checkCircle,
  'checkbox-multi': checkboxMulti,
  'checkbox-off': checkboxOff,
  'checkbox-on': checkboxOn,
  checkmark: checkmark,
  'chevron-double-down': chevronDoubleDown,
  'chevron-double-left': chevronDoubleLeft,
  'chevron-double-right': chevronDoubleRight,
  'chevron-double-up': chevronDoubleUp,
  'chevron-down': chevronDown,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'chevron-up': chevronUp,
  close: close,
  comment: comment,
  compass: compass,
  corp: corp,
  courthouse: courthouse,
  diagram: diagram,
  dial: dial,
  disk: disk,
  'document-list-two': documentListTwo,
  'document-list': documentList,
  download: download,
  drawer: drawer,
  duplicate: duplicate,
  ellipsis: ellipsis,
  'envelope-open': envelopeOpen,
  envelope: envelope,
  envelopes: envelopes,
  'exclamation-diamond': exclamationDiamond,
  'exclamation-circle-alt': exclamationCircleAlt,
  'exclamation-circle': exclamationCircle,
  'exclamation-triangle-alt': exclamationTriangleAlt,
  'exclamation-triangle': exclamationTriangle,
  expand: expand,
  eye: eye,
  'file-cabinet': fileCabinet,
  'file-excel': fileExcel,
  'file-pdf': filePdf,
  'file-powerpoint': filePowerpoint,
  'file-word': fileWord,
  file: file,
  files: files,
  filter: filter,
  'first-page': firstPage,
  flag: flag,
  folder: folder,
  gear: gear,
  headset: headset,
  home: home,
  'info-circle-alt': infoCircleAlt,
  'info-circle': infoCircle,
  key: key,
  'last-page': lastPage,
  link: link,
  list: list,
  lists: lists,
  lock: lock,
  logout: logout,
  magnify: magnify,
  menu: menu,
  minimize: minimize,
  mobile: mobile,
  'move-horizontal': moveHorizontal,
  'move-point': movePoint,
  'move-vertical': moveVertical,
  no: no,
  paperclip: paperclip,
  pencil: pencil,
  'plus-circle-alt': plusCircleAlt,
  'plus-circle': plusCircle,
  plus: plus,
  popin: popin,
  popout: popout,
  'question-circle-outline': questionCircleOutline,
  'question-circle': questionCircle,
  'question-square': questionSquare,
  'radio-off': radioOff,
  'radio-on': radioOn,
  realtime: realtime,
  redo: redo,
  'refresh-square': refreshSquare,
  refresh: refresh,
  restricted: restricted,
  'scale-down': scaleDown,
  'scale-up': scaleUp,
  share: share,
  star: star,
  stop: stop,
  subscribe: subscribe,
  'talk-bubble': talkBubble,
  'thumbs-down-fill': thumbsDownFill,
  'thumbs-down-outline': thumbsDownOutline,
  'thumbs-up-fill': thumbsUpFill,
  'thumbs-up-outline': thumbsUpOutline,
  timer: timer,
  trash: trash,
  undo: undo,
  unlink: unlink,
  unlock: unlock,
  upload: upload,
  user: user,
  'user-gear': userGear,
  'user-key': userKey,
  'x-circle-alt': xCircleAlt,
  'x-circle': xCircle,
  x: x,
  zoom: zoom
};